import { DateTime } from 'luxon';
import { ConfigurationService } from '../../../services/configuration.service';

export class SystemClock {
  public static now(): DateTime {
    try {
      if (ConfigurationService.get('paegnaben.systemclock.isreal') === 'false') {
        const fakeSystemClockNow = ConfigurationService.get('paegnaben.systemclock.now');
        const parsedTime = fakeSystemClockNow ? DateTime.fromISO(fakeSystemClockNow) : DateTime.now();
        if (parsedTime.isValid) return parsedTime;
        return DateTime.now();
      }
      return DateTime.now();
    } catch {
      return DateTime.now();
    }
  }
}
